/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Generators_TitleInputs */

const en_directory_tools_generators_title = /** @type {(inputs: Directory_Tools_Generators_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI generators`)
};

const zh_directory_tools_generators_title = /** @type {(inputs: Directory_Tools_Generators_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 生成器`)
};

/**
* | output |
* | --- |
* | "AI generators" |
*
* @param {Directory_Tools_Generators_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_generators_title = /** @type {((inputs?: Directory_Tools_Generators_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Generators_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_generators_title(inputs)
	return zh_directory_tools_generators_title(inputs)
});
export { directory_tools_generators_title as "directory.tools.generators_title" }